import { render, staticRenderFns } from "./HistorySearch.vue?vue&type=template&id=2c9cb266"
import script from "./HistorySearch.vue?vue&type=script&lang=js"
export * from "./HistorySearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c9cb266')) {
      api.createRecord('2c9cb266', component.options)
    } else {
      api.reload('2c9cb266', component.options)
    }
    module.hot.accept("./HistorySearch.vue?vue&type=template&id=2c9cb266", function () {
      api.rerender('2c9cb266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/HistorySearch.vue"
export default component.exports